import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest, PaginationType } from '../../types/pagination';
import { DefaultRequest, SortRequest, WithArchiveRequest } from '../../types/props';
import { managerApiUrl, UserRole } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

const baseUrl = `${managerApiUrl}/admins`;

export type AdminType = {
  id: number;
  login: string;
  name: LangType;
  surname: LangType;
  patronymic: string[];
  email: string;
  iin: string;
  phone: string;
  branches: number[];
  role: UserRole;
  is_deleted: boolean;
  created_at: string;

  // app fields
  password?: string;
  repeat_password?: string;
};

export interface FetchAdminsRequest
  extends PaginationRequest,
    SortRequest,
    WithArchiveRequest,
    DefaultRequest,
    Pick<AdminType, 'role' | 'branches' | 'login' | 'email'> {
  from?: string;
  to?: string;
}

export const fetchAdmins = async (
  request: Partial<FetchAdminsRequest>,
): Promise<PaginationType & { admins: AdminType[] }> => {
  const response = await baseFetch(baseUrl + buildParams(request));
  return response;
};

export const postAdmin = async (request: Partial<AdminType>): Promise<AdminType> => {
  const response = await baseFetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(request),
  });
  return response;
};

export const putAdmin = async (request: Partial<AdminType>) => {
  const response = await baseFetch(`${baseUrl}/${request.id}`, {
    method: 'PUT',
    body: JSON.stringify(request),
  });
  return response;
};

export const deleteAdmin = async (id: string) => {
  const response = await baseFetch(`${baseUrl}/${id}`, {
    method: 'DELETE',
  });
  return response;
};

export const restoreAdmin = async (id: string) => {
  const response = await baseFetch(`${baseUrl}/${id}/restore`, {
    method: 'POST',
  });
  return response;
};
